import React from 'react';
import Slider from "react-slick";
import SvgIconDPC from "../dpc-svg-icon";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class DpcPhotoGallerySingola extends React.Component {

    constructor(props) {
        super(props);
        this.settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SvgIconDPC name='chevron-right'/>,
            prevArrow: <SvgIconDPC name='chevron-left'/>,          
        };
    }

    render() {
        return (
            <div class="gallery-photo-video-embed">
            <div class="gallery-bg-dark">
              <div class="it-carousel-wrapper">
                <div class="it-carousel-all it-img-card">
                <Slider {...this.settings}>
                  { this.props.galleria.map(item =>
                  <div class="it-single-slide-wrapper">
                    <div class="card-wrapper">
                      <div class="card card-img no-after">
                        <div class="img-responsive-wrapper">
                          <div class="img-responsive">
                            <div class="img-wrapper">
                                <img src={item.relationships.image.localFile.childImageSharp.fluid.src} alt={item.field_alt} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
               </Slider>
                </div>
              </div>
            </div>
          </div>
        )
    }

}
